/** Pulse tracker configuration (shared constants). */

/** Master kill switch — also gated by REACT_APP_PULSE_TRACKER_ENABLED. */
export const PULSE_TRACKER_ENABLED_ENV = 'REACT_APP_PULSE_TRACKER_ENABLED';
export const PULSE_COLLECTOR_URL_ENV = 'REACT_APP_PULSE_COLLECTOR_URL';

/**
 * fetch keepalive bodies are capped at 64KB by the browser; over that the request
 * is rejected outright. Skip keepalive above this threshold.
 */
export const PULSE_KEEPALIVE_MAX_BYTES = 60 * 1024;

/** Flush tracing. Enable with REACT_APP_PULSE_DEBUG=true. */
export const PULSE_DEBUG_ENV = 'REACT_APP_PULSE_DEBUG';

/**
 * Desktop profile scrollspy: wait for scroll to settle before firing a view.
 * Avoids firing every section when jumping 1st → 4th tab (smooth scroll passes through).
 * ScrollspyNav duration is 500ms — debounce should be shorter than a deliberate pause,
 * and click suppress should cover the full animation.
 */
export const PULSE_PROFILE_SCROLL_DEBOUNCE_MS = 350;
/** Ignore scroll-driven views after a sidebar click (ms). */
export const PULSE_PROFILE_CLICK_SCROLL_SUPPRESS_MS = 600;

/**
 * Click / interaction events (ARD taps). Independent of view tracking.
 * Code switch + env (default on when unset; set REACT_APP_PULSE_CLICK_EVENTS_ENABLED=false to disable).
 * Still requires REACT_APP_PULSE_TRACKER_ENABLED=true for transport.
 */
export const PULSE_CLICK_EVENTS_ENABLED = true;
export const PULSE_CLICK_EVENTS_ENABLED_ENV = 'REACT_APP_PULSE_CLICK_EVENTS_ENABLED';
